/**
 * Terms of Service page
 */

import {LandingLayout} from '../../components/layout/LandingLayout';
import {Container} from '../../components/ui/Container';
import {Section} from '../../components/ui/Section';
import {SectionHeader} from '../../components/ui/SectionHeader';

export function TermsPage() {
  return (
    <LandingLayout>
      <Section padding="lg" background="white" className="pt-32 bg-background dark:bg-[#1E1E1E]">
        <Container className="max-w-4xl">
          <SectionHeader
            title="Terms of Service"
            subtitle={`Last updated: ${new Date().toLocaleDateString()}`}
            centered
            size="lg"
          />

          <div className="prose prose-lg max-w-none text-textSecondary dark:text-[#858585] space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Agreement to Terms</h2>
              <p>
                By accessing or using VoxaPilot, you agree to be bound by these Terms of Service.
                If you disagree with any part of these terms, you may not access the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Use License</h2>
              <p>Permission is granted to temporarily use VoxaPilot for personal or commercial use. This license does not include:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modifying or copying the materials</li>
                <li>Using the materials for any commercial purpose without permission</li>
                <li>Attempting to reverse engineer any software</li>
                <li>Removing any copyright or proprietary notations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">User Accounts</h2>
              <p>
                When you create an account with us, you must provide accurate and complete
                information. You are responsible for safeguarding your account credentials and for
                all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Acceptable Use</h2>
              <p>You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the service for any illegal purpose</li>
                <li>Violate any laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Transmit any harmful or malicious code</li>
                <li>Interfere with or disrupt the service</li>
                <li>Attempt to gain unauthorized access to the service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Content and Intellectual Property</h2>
              <p>
                The service and its original content, features, and functionality are owned by
                VoxaPilot and are protected by international copyright, trademark, and other
                intellectual property laws. You retain ownership of any content you submit, but
                grant us a license to use it to provide the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Payment Terms</h2>
              <p>
                If you purchase a subscription, you agree to pay all fees associated with your
                chosen plan. Fees are billed in advance on a monthly or annual basis. You may cancel
                your subscription at any time, but refunds are subject to our refund policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Termination</h2>
              <p>
                We may terminate or suspend your account immediately, without prior notice, for any
                breach of these Terms. Upon termination, your right to use the service will cease
                immediately.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Disclaimer</h2>
              <p>
                The service is provided "as is" without warranties of any kind, either express or
                implied. We do not warrant that the service will be uninterrupted, secure, or error-free.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Limitation of Liability</h2>
              <p>
                In no event shall VoxaPilot be liable for any indirect, incidental, special, or
                consequential damages arising out of or in connection with your use of the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. We will notify users of any
                material changes by posting the new terms on this page.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Contact Information</h2>
              <p>
                If you have questions about these Terms, please contact us at:{' '}
                <a href="mailto:legal@voxapilot.com" className="text-accent dark:text-orange-500 hover:underline">
                  legal@voxapilot.com
                </a>
              </p>
            </section>
          </div>
        </Container>
      </Section>
    </LandingLayout>
  );
}

